import React from 'react';
import { KeyTurnMark } from './KeyTurnMark';
import { navLinks, signInUrl } from '../data/site';
export function SiteFooter() {
  return <footer className="border-t border-line bg-cream" data-id="element-279" data-mp="3r8rfumw9e3ws">
      <div className="mx-auto flex max-w-[1180px] flex-col gap-8 px-5 py-12 sm:flex-row sm:items-end sm:justify-between sm:px-8" data-id="element-280" data-mp="3mh1206y44y0m">
        <div className="max-w-sm" data-id="element-281" data-mp="3hhoinw6ga92s">
          <div className="flex items-center gap-2.5" data-id="element-282" data-mp="3hglqzm1b02lt">
            <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-charcoal-700" data-id="element-283" data-mp="3dhmengd8t3kc">
              <KeyTurnMark size={16} data-id="element-284" data-mp="38gyp6z4nwus8" />
            </span>
            <span className="font-display text-[17px] font-semibold tracking-[-0.02em] text-charcoal-700" data-id="element-285" data-mp="33ioq4dftha1c">
              KeyTurn
            </span>
          </div>
          <p className="mt-3 text-[12.5px] text-charcoal-400" data-id="element-286" data-mp="2ylew0khhga76">
            KeyTurn by{' '}
            <a href="https://staydisrupted.com" target="_blank" rel="noopener noreferrer" className="font-medium text-charcoal-700 underline decoration-warmgrey-300 decoration-1 underline-offset-2 transition-colors duration-150 ease-smooth hover:decoration-charcoal-700" data-id="element-287" data-mp="11qs9ipesl9zp">
              Stay Disrupted
            </a>
          </p>
          <p className="mt-4 text-[13px] leading-relaxed text-charcoal-400" data-id="element-288" data-mp="vu8pohsh44gc">
            Hotel project intelligence for openings, takeovers, rebrands and group rollouts. KeyTurn
            does the managing, so your team can focus on decisions and outcomes.
          </p>
        </div>

        <nav aria-label="Footer" className="flex flex-wrap gap-x-8 gap-y-3" data-id="element-289" data-mp="1tf4qvsz8ur24">
          {navLinks.map(link => <a key={link.href} href={link.href} className="text-[13px] text-charcoal-400 transition-colors duration-150 ease-smooth hover:text-charcoal-700" data-id="element-290" data-mp="1er9vg4tuq8lc">
              {link.label}
            </a>)}
          <a href={signInUrl} className="text-[13px] text-charcoal-400 transition-colors duration-150 ease-smooth hover:text-charcoal-700" data-id="element-291" data-mp="2c7z70q8lsp7x">
            Sign in
          </a>
          <a href="#demo" className="text-[13px] font-medium text-charcoal-700 transition-colors duration-150 ease-smooth hover:text-gold-600" data-id="element-292" data-mp="2h54kxenrcufr">
            Book a demonstration
          </a>
        </nav>
      </div>

      <div className="border-t border-line" data-id="element-293" data-mp="2341vcrxk1203">
        <p className="mx-auto max-w-[1180px] px-5 py-6 text-[11.5px] text-charcoal-300 sm:px-8" data-id="element-294" data-mp="2353gxqc756w2">
          © {new Date().getFullYear()} KeyTurn. All rights reserved.
        </p>
      </div>
    </footer>;
}